<template lang="pug">
  md-card
    md-card-header(data-background-color="green")
      h4(class="title") Analyst Group Time Slots
      p(class="category") Select a time that works best for you
    md-card-content
      md-table
        md-table-row
          md-table-cell Time
        md-table-row(v-for="group in allGroups" :key="group.analyst_group_id")
          md-table-cell {{ group.day }} @ {{ group.hour - 12}} pm
          md-table-cell
            md-button.md-raised(@click="registerTime(group.analyst_group_id)") Join Timeslot
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      allGroups: null,
      error: null,
      success: null,
    }
  },
  created() {
    axios.get('/api/org/analyst_groups')
    .then((res) => {
      this.allGroups = res.data;
    }).catch((err) => {
      this.error = true;
    })
  },
  methods: {
    registerTime(groupID) {
      axios.post(`/api/org/analyst_groups/${groupID}/users`)
      .then((res) => {
        this.success = true;
        this.$router.go();
      }).catch((err) => {
        this.error = true;
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/AnalystGroup/AnalystGroupRegister.vue